export default "__VITE_ASSET__BFA7G5qO__"